import { useEffect, useState } from 'react';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import { waLink, WHATSAPP_DISPLAY } from '../data/whatsapp';

const { FaWhatsapp } = FaIcons;

function WhatsAppFloat() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <a
      className={show ? 'wa-float visible' : 'wa-float'}
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <span className="wa-float-icon"><SafeIcon icon={FaWhatsapp} /></span>
      <span className="wa-float-text">
        <strong>Contact Us</strong>
        <small>{WHATSAPP_DISPLAY}</small>
      </span>
    </a>
  );
}
export default WhatsAppFloat;
